const reference = value => String(value?._id || value?.id || value || "");
const isCv = row => row.automationKey === "cv-follow" || row.presentationIds?.length || /cv[-_ ]?(delivery|presentation)|cv anonymis|cv propos/i.test(String(row.type || row.title || ""));
export function latestClientComment(client, state, actions = []) {
  const ids = new Set([client.id, client.client_id, client._id, client.establishment_id].filter(Boolean).map(reference));
  const linked = row => ids.has(reference(row.clientId || row.establishment_id || row.client));
  const candidates = [
    ...(state.results || []).filter(linked).map(row => ({text:row.notes || row.comment || row.details?.notes,date:row.createdAt})),
    ...(state.tasks || []).filter(linked).filter(row => !isCv(row)).map(row => ({text:row.notes || row.comment || row.details?.notes,date:row.createdAt})),
    ...(client.comments || []).map(row => ({text:row.comment,date:row.createdAt})),
    ...actions.filter(row => !isCv(row)).map(row => ({text:row.comment || row.description || row.detail,date:row.at || row.createdAt})),
  ].filter(row => typeof row.text === 'string' && row.text.trim());
  candidates.sort((a,b) => (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0));
  return candidates[0] || null;
}
